import { BaseAction, DataAction } from 'src/CustomTypes'
import { CURRENT_VIEW } from '../actions/InfoMenuActions'

export enum InfoView {
  Empty,
  BoreholeInfo,
  VirtualBoreholeInfo
}

export interface InfoMenuState {
  currentView: InfoView
}

export const infoMenuStateInitial: InfoMenuState = {
  currentView: InfoView.Empty
}

export function infoMenuReducer (
  state: InfoMenuState = infoMenuStateInitial, // eslint-disable-line @typescript-eslint/default-param-last
  action: BaseAction): InfoMenuState {
  switch (action.type) {
    case CURRENT_VIEW: {
      const a = action as DataAction<InfoView>
      return {
        ...state,
        currentView: a.data
      }
    }
    default:
      return state
  }
}
